import React, { useState } from "react";

import { Rating } from "@material-ui/core";
import { Star } from "@material-ui/icons";

import "./Dish.css";

export default function Dish(props) {
  const [isClosed, setIsClosed] = useState(true);
  return (
    <ul className="ul">
      <input type="checkbox" id="collapse" />
      <label
        className="dish-label"
        for="collapse"
        onClick={() => setIsClosed(!isClosed)}
      >
        {props.name}
        <h>
          {
            <Rating
              sx={{ color: "#f5f5f5" }}
              value={props.overallRate}
              readOnly
              precision={0.1}
              emptyIcon={<Star style={{ opacity: 0.6 }} />}
            />
          }
          ({props.overallReviewers} reviews){" "}
        </h>
      </label>
      <div style={{ display: isClosed ? "none" : "block" }}>
        {props.token ? (
          <li className="li">
            <button className="bu" onClick={props.modal}>
              Add Review
            </button>
          </li>
        ) : null}

        {props.description ? (
          <li className="li">Description: {props.description}</li>
        ) : null}

        <li className="li">
          Cost-benefit{" "}
          {props.benefitRate
            ? parseFloat(props.benefitRate).toFixed(1)
            : "No reviews"}{" "}
          ({props.benefitReviewers} reviews)
        </li>
        <li className="li">
          Taste{" "}
          {props.tasteRate
            ? parseFloat(props.tasteRate).toFixed(1)
            : "No reviews"}{" "}
          ({props.tasteReviewers} reviews)
        </li>
        <li className="li">
          {" "}
          Presentation{" "}
          {props.presentationRate
            ? parseFloat(props.presentationRate).toFixed(1)
            : "No reviews"}
          ({props.presentationReviewers} reviews)
        </li>
        <li className="li">
          Size{" "}
          {!props.sizeRate
            ? "No reviews"
            : props.sizeRate >= 4.5
            ? "Huge"
            : props.sizeRate >= 3.5 && props.sizeRate < 4.5
            ? "Big"
            : props.sizeRate >= 2.5 && props.sizeRate < 3.5
            ? "Medium"
            : props.sizeRate >= 1.5 && props.sizeRate < 2.5
            ? "Small"
            : props.sizeRate && props.sizeRate < 1.5
            ? "Tiny"
            : null}{" "}
          ({props.sizeReviewers} reviews)
        </li>
      </div>
    </ul>
  );
}
